<form [formGroup]="form" class="w-full flex flex-wrap justify-center content-start">
    <span class="w-full text-base font-medium text-start mb-2">ورود با رمز عبور</span>
    <span class="w-full text-xs font-regular text-start mb-5">نام کاربری،شمارهٔ موبایل یا آدرس ایمیل به همراه رمز عبور
        خود را وارد کنید.</span>

    <input formControlName="userName" class="w-full mb-3 !bg-white border !border-[#BDBDBD] dark:!bg-gray-700 dark:!border-gray-700" type="text"
        placeholder="نام کاربری، شمارهٔ موبایل یا آدرس ایمیل">


    <div class="relative w-full mb-5 rounded-lg">
        <input StandardNumber formControlName="password" class="w-full !bg-white border !border-[#BDBDBD] dark:!bg-gray-700 dark:!border-gray-700" type="text"
            placeholder="رمز عبور (حداقل ۶ کاراکتر)" [type]="passwordVisible ? 'text' : 'password'">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 icon text-base text-gray-500 cursor-pointer"
            (click)="passwordVisible = !passwordVisible" [ngClass]="passwordVisible ? 'eye-off-filled' : 'eye-regular'">
        </span>
    </div>

    <!-- <input formControlName="userName" class="w-full mb-6 !bg-white border !border-[#BDBDBD]" type="text" placeholder="رمز عبور"> -->
    <button class="w-full btn btn btn-green-flat mb-2 md:mt-6" [appButtonLoader]="loginLoading" [disabled]="form.invalid"
        (click)="submit()">ورود</button>
    <div class="w-full flex flex-wrap justify-between content-center">
        <button class=" btn btn-green mb-5 !p-0" (click)="forgetPassword()">فراموشی رمز عبور</button>
        <button class=" btn btn-green mb-5 !p-0" (click)="loginWithOtp()">ورود با رمز یکبار مصرف</button>
    </div>
</form>